var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVk = function SvgVk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    className: "vk_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M181.76 181.76C128 236.032 128 322.816 128 496.64v30.72c0 173.568 0 260.352 53.76 314.88C236.032 896 322.816 896 496.64 896h30.72c173.568 0 260.352 0 314.88-53.76C896 787.968 896 701.184 896 527.36v-30.72c0-173.568 0-260.352-53.76-314.88C787.968 128 701.184 128 527.36 128h-30.72c-173.568 0-260.352 0-314.88 53.76m75.776 179.968H345.6c2.816 146.432 67.328 208.384 118.528 221.184V361.728h82.688v126.208c50.432-5.376 103.68-62.976 121.6-126.464h82.432A243.93 243.93 0 0 1 638.72 520.96a252.59 252.59 0 0 1 131.328 160.256h-90.88c-19.456-60.672-68.096-107.776-132.352-114.176v114.176h-10.24c-175.104 0-274.944-119.808-279.04-319.488"
  })));
};
export default SvgVk;